export enum SummaryGeneratingStatus {
  Pending = "pending",
  Success = "success",
  Error = "error",
}
